import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouteReuseStrategy } from '@angular/router';
import { AbcCommonEditorsModule } from '@barthauer/abc/common-editors';
import {
  AbcAutoCompleteInputModule,
  AbcDateBoxComponent,
  AbcDropDownBoxComponent,
  AbcTileNavMenuModule,
  AbcMediaGalleryComponent,
} from '@barthauer/abc/ui-components';
import { DxButtonGroupModule, DxDateBoxModule, DxPopupModule } from 'devextreme-angular';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { WidgetsRoutingReuseStrategy } from '../widgets-routing.reuseStrategy';
import { TicketDetailComponent } from './ticket-detail/ticket-detail.component';
import { TicketListComponent } from './ticket-list/ticket-list.component';
import { TicketNavigationComponent } from './ticket-navigation/ticket-navigation.component';
import { TicketsRoutingModule } from './tickets-routing.module';
import { TicketsService } from './tickets.service';
import { TicketsComponent } from './tickets/tickets.component';

@NgModule({
  declarations: [TicketsComponent, TicketListComponent, TicketDetailComponent, TicketNavigationComponent],
  imports: [
    CommonModule,
    FormsModule,
    TicketsRoutingModule,
    MatToolbarModule,
    MatSortModule,
    FlexLayoutModule,
    MatIconModule,
    MatMenuModule,
    MatChipsModule,
    MatCardModule,
    MatStepperModule,
    MatButtonModule,
    MatCheckboxModule,
    DxButtonGroupModule,
    DxDateBoxModule,
    DxPopupModule,
    ScrollingModule,
    AbcTileNavMenuModule,
    AbcCommonEditorsModule,
    AbcDateBoxComponent,
    AbcDropDownBoxComponent,
    AbcAutoCompleteInputModule,
    MatTabsModule,
    AbcMediaGalleryComponent,
  ],
  providers: [TicketsService, { provide: RouteReuseStrategy, useClass: WidgetsRoutingReuseStrategy }],
})
export class TicketsModule {}
